declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function loadAnalytics(): void {
  if (!GA_MEASUREMENT_ID) return;
  if (window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  const w = window as unknown as { dataLayer: any[]; gtag?: (...args: any[]) => void };
  w.gtag = function(){ w.dataLayer.push(arguments as unknown as never); };

  w.gtag('js', new Date());
  w.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path: string): void {
  const w = window as unknown as { gtag?: (...args: any[]) => void };
  if (!GA_MEASUREMENT_ID || !w.gtag) return;
  w.gtag('event', 'page_view', {
    page_path: path,
  });
}

export function trackEvent(eventName: string, params?: Record<string, any>): void {
  const w = window as unknown as { gtag?: (...args: any[]) => void };
  if (!GA_MEASUREMENT_ID || !w.gtag) return;
  w.gtag('event', eventName, params || {});
}


